// Shared drag/drop visual-feedback colors - WordBucket and DraggableSnap
// both paint these via raw DOM style writes (not CSS classes, since
// they're applied imperatively during native drag events) during the
// same handful of interactions, so one source keeps the two from
// drifting out of sync.
export const CORRECT_DROP_COLOR = 'green';
export const INCORRECT_DROP_COLOR = 'red';
export const BUCKET_HOVER_COLOR = '#FFFB8015';
export const BUCKET_MISS_HOVER_COLOR = '#5ead4454';
export const CORRECT_WORD_TEXT_COLOR = '#8955D9'; // matches --brand in main.css
